var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _require = require('./addresses'),
    isValidAddress = _require.isValidAddress;

var _require2 = require('./constant'),
    PRIVATE_ADDRESS_VALID_PREFIXES = _require2.PRIVATE_ADDRESS_VALID_PREFIXES;

function getPrivateAddress(_x, _x2) {
  return _getPrivateAddress.apply(this, arguments);
}

function _getPrivateAddress() {
  _getPrivateAddress = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(walletd, address) {
    var walletAddress;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isValidAddress(address)) {
              _context.next = 2;
              break;
            }

            throw new Error("".concat(address, " is not a valid address"));

          case 2:
            if (!PRIVATE_ADDRESS_VALID_PREFIXES.has(address.substring(0, 2))) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", address);

          case 4:
            _context.next = 6;
            return walletd.call('address', {
              address: address
            });

          case 6:
            walletAddress = _context.sent;
            return _context.abrupt("return", walletAddress.secret);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getPrivateAddress.apply(this, arguments);
}

module.exports = {
  getPrivateAddress: getPrivateAddress
};